import { useEffect, useRef, useState } from 'react';
import {
    Form,
    Container,
    Row,
    Col,
    Button,
    Stack,
    ListGroup,
    Modal,
    Spinner,
} from 'react-bootstrap';
import { Check, CircleAlert } from 'lucide-react';
import './eyetestList.scss';
import {
    useEyetestAddMutation,
    useTestNamesMutation,
    useUpload1Mutation,
    useUpload2Mutation,
    useUpload3Mutation,
} from './eyetestApi';
import {
    useAllPatientListMutation,
    useAllPatientDropdownListMutation,
} from '../Patient/patientApi';
import Step1 from './step1';
import Step2 from './step2';
import Step3 from './step3';
import Step4 from './step4';
import { useLocation, useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import LoadingComponent from '../LoadingComponent';
import Preview from './preview';
import { usePosListMutation } from '../Pos/posApi';
import { useOpticianListMutation } from '../Optician/opticianApi';
import { useDoctorListMutation } from '../Doctor/doctorApi';
import Swal from 'sweetalert2';
import { useOutletContext } from 'react-router';
import { setSecureItem, getSecureItem } from "../../utils/secureStorage";
const config = {
    testno: '0',
    testDetails: [
        {
            testType: 'Test au fronto',
            whichEye: 'right',
            sph: '0.00',
            cyl: '0.00',
            axe: '0.00',
            add: '0.00',
            pd: '0.00',
            orderNo: 1,
        },
        {
            testType: 'Test au fronto',
            whichEye: 'left',
            sph: '0.00',
            cyl: '0.00',
            axe: '0.00',
            add: '0.00',
            pd: '0.00',
            orderNo: 2,
        },
        {
            testType: 'Auto ref',
            whichEye: 'right',
            sph: '0.00',
            cyl: '0.00',
            axe: '0.00',
            add: '0.00',
            pd: '0.00',
            orderNo: 3,
        },
        {
            testType: 'Auto ref',
            whichEye: 'left',
            sph: '0.00',
            cyl: '0.00',
            axe: '0.00',
            add: '0.00',
            pd: '0.00',
            orderNo: 4,
        },
        {
            testType: 'Réfraction subjective (manuelle)',
            whichEye: 'right',
            sph: '0.00',
            cyl: '0.00',
            axe: '0.00',
            add: '0.00',
            pd: '0.00',
            orderNo: 5,
        },
        {
            testType: 'Réfraction subjective (manuelle)',
            whichEye: 'left',
            sph: '0.00',
            cyl: '0.00',
            axe: '0.00',
            add: '0.00',
            pd: '0.00',
            orderNo: 6,
        },
        {
            testType: 'Reco opticien',
            whichEye: 'right',
            sph: '0.00',
            cyl: '0.00',
            axe: '0.00',
            add: '0.00',
            pd: '0.00',
            orderNo: 7,
        },
        {
            testType: 'Reco opticien',
            whichEye: 'left',
            sph: '0.00',
            cyl: '0.00',
            axe: '0.00',
            add: '0.00',
            pd: '0.00',
            orderNo: 8,
        },
    ],
    opticianEmail: '',
    patientEmail: '',
    posEmail: '',
    needPrescription: '',
    acteGratuit: true,
    info_Acuity_Near_Vision_Right_Eye: '',
    info_Acuity_Near_Vision_Left_Eye: '',
    info_Acuity_Distance_Vision_Right_Eye: '',
    info_Acuity_Distance_Vision_Left_Eye: '',
    info_Acuity_visual_sans_correction_Right_Eye: '',
    info_Acuity_visual_sans_correction_Left_Eye: '',
    info_Eye_Pressure_Right_Eye: '',
    info_Eye_Pressure_Left_Eye: '',
    isMutualCompany: '',
    testNameId: 1,
    glasses: 0,
    status: 'New',
    name: '',
    lastTimeWentToEyeDoc: undefined,
    noteOpt: '',
    symptoms: 'false, false, false, false, false, false, false, false, false',
    dignosedwith: 'false, false, false, false, false, false, false, false',
    healthConditions: 'false, false, false, false',
    symptomComment: '',
    isPrescriptionDownload: false,
    isContactLensType: false,
    commentsForPrescription: '',
    commentForLenses: '',
    commentaireInterne: '',
    isImageRetino: '',
    imageRetinoSpecification: '',
    resultExamine: '',
    InfoSubmitTrack: 'Web',
    imagesVues: 'N/A',
    infoPrescriptionToOptician: false,
    isExpressTest: false,
    doYouWearGlasses: '',
    typeOfVision: '',
};

const EyeTestAdd = () => {
    const { t } = useTranslation();

    const steps = [
        {
            title: t('basicInfo'),
        },
        {
            title: t('symptoms'),
        },
        {
            title: t('eyeCheckUp'),
        },
        {
            title: t('comments'),
        },
    ];

    const defaultError = {
        lastTimeWentToEyeDoc: false,
        posEmail: false,
        patientEmail: false,
        opticianEmail: false,
        symptoms: false,
        dignosedwith: false,
        healthConditions: false,
        auto_ref: false,
        refraction: false,
        reco_opticien: false,
        info_Acuity_Near_Vision_Left_Eye: false,
        info_Acuity_Distance_Vision_Left_Eye: false,
        info_Acuity_Near_Vision_Right_Eye: false,
        info_Acuity_Distance_Vision_Right_Eye: false,
        infoPrescriptionToOptician: false,
    };
    const { state } = useLocation();

    const navigate = useNavigate();
    const user = getSecureItem('UserData');
    const [loading, setLoading] = useState(true);
    const [buttonLoading, setButtonLoading] = useState(false);
    const [modalActive, setModalActive] = useState(false);
    const imageConfig = {
        image1: '',
        image2: '',
        image3: '',
    };
    const [images, setImages] = useState(imageConfig);
    const [currentStep, setCurrentStep] = useState(1);
    const [selectedPatientAge, setSelectedPatientAge] = useState();
    const [error, setError] = useState({});
    useEffect(() => {
        console.log('error +++++++> ', error);
    }, [error]);
    const [testDetailsAddModal, setTestDetailsAddModal] = useState(false);
    const [testDetailsSPHModal, setTestDetailsSPHModal] = useState(false);
    const [testDetailsCYLModal, setTestDetailsCYLModal] = useState(false);

    const [isImageValid, setIsImageValid] = useState(false);
    const [testDetailsAddModalCount, setTestDetailsAddModalCount] =
        useState(true);
    const [testDetailsSPHModalCount, setTestDetailsSPHModalCount] =
        useState(true);
    const [testDetailsCYLModalCount, setTestDetailsCYLModalCount] =
        useState(true);

    // ===================================
    const [sphcylvalueModal, setSphcylvalueModal] = useState(false);
    const [sphcylvalueModalFor2ndTime, setSphcylvalueModalFor2ndTime] =
        useState(false);

    const [patientWearsGlassesModal, setPatientWearsGlassesModal] =
        useState(false);
    const [
        patientWearsGlassesModalFor2ndTime,
        setPatientWearsGlassesModalFor2ndTime,
    ] = useState(false);

    const [progressivewarningModal, setProgressivewarningModal] =
        useState(false);
    const [
        progressivewarningModalFor2ndTime,
        setProgressivewarningModalFor2ndTime,
    ] = useState(false);
    const [neverSeenWarningModal, setNeverSeenWarningModal] = useState(false);
    const [neverSeenWarningShown, setNeverSeenWarningShown] = useState(false);
    const [refractionNotIdenticalModal, setRefractionNotIdenticalModal] =
        useState(false);
    const [
        refractionNotIdenticalModalFor2ndTime,
        setRefractionNotIdenticalModalFor2ndTime,
    ] = useState(false);
    // ===================================
    const [symptomcomment, setSymptomcomment] = useState(false);
    useEffect(() => {
        console.log('symptomcomment +++++++++++++++++++++> ', symptomcomment);
    }, [symptomcomment]);

    const [preview, setPreview] = useState(false);
    const [addEyeTestConfig, setAddEyeTestConfig] = useState({
        ...config,
        isContactLensType: state.glass ? false : true,
    });
    useEffect(() => {
        console.log('addEyeTestConfig ==============> ', addEyeTestConfig);
    }, [addEyeTestConfig]);
    const { scrollContainerRef } = useOutletContext();

    // State to track character count errors for each textarea
    const [charLimitErrors, setCharLimitErrors] = useState({
        commentsForPrescription: false,
        noteOpt: false,
        commentaireInterne: false,
        isMutualCompany: false,
        commentForLenses: false,
        comment: false,
    });

    useEffect(() => {
        console.log('addEyeTestConfig ==== ', addEyeTestConfig);
        console.log(
            'addEyeTestConfig.optician ==== ',
            addEyeTestConfig.opticianEmail
        );
    }, [addEyeTestConfig]);

    const [testNames] = useTestNamesMutation();
    const [addEyeTest] = useEyetestAddMutation();
    const [posListMutation] = usePosListMutation();
    const [doctorListMutation] = useDoctorListMutation();
    const [opticianListMutation] = useOpticianListMutation();
    const [patientListMutation] = useAllPatientListMutation();
    const [patientDropdownListMutation] = useAllPatientDropdownListMutation();
    const [imageUpload1] = useUpload1Mutation();
    const [imageUpload2] = useUpload2Mutation();
    const [imageUpload3] = useUpload3Mutation();
    const hasCorrectionCarriedValues = (details) => {
        const frontoList = details.filter(
            (item) => item.testType === 'Test au fronto'
        );

        const hasAnyValue = (item) =>
            item.sph !== '0.00' ||
            item.cyl !== '0.00' ||
            item.axe !== '0.00' ||
            item.add !== '0.00' ||
            item.pd !== '0.00';

        return frontoList.some(hasAnyValue);
    };
    const handleNextStep = () => {
        // 🔒 Step 1: Contact lens age validation
        if (currentStep === 1 && !state?.glass) {

            // Age not loaded yet → block
            if (typeof selectedPatientAge !== 'number') {
                Swal.fire({
                    icon: 'warning',
                    title: t('attention'),
                    text: t('pleaseSelectPatientAndWait'),
                });
                return;
            }

            // Under 18 → block
            if (selectedPatientAge < 18) {
                setModalActive(true);
                return; // ⛔ HARD STOP
            }
        }

        // ✅ Safe to proceed
        setCurrentStep((prevStep) =>
            Math.min(prevStep + 1, steps.length)
        );
    };
    const handlePrevStep = () => {
        if (currentStep == 1) {
            navigate(-1);
        }
        setCurrentStep((prevStep) => Math.max(prevStep - 1, 1));
    };

    // useEffect(() => {
    //     if (loading) {
    //         (async () => {
    //             let tempPosList = await posListMutation({
    //                 email: '',
    //                 mobile: '',
    //             });
    //             let tempDoctorList = await doctorListMutation({
    //                 email: '',
    //                 mobile: '',
    //             });
    //             let tempOpticianList = await opticianListMutation({
    //                 email: '',
    //                 mobile: '',
    //             });
    //             // let tempPatientList = await patientListMutation({
    //             //     email: '',
    //             //     mobile: '',
    //             // });
    //             let tempPatientDropdownList = await patientDropdownListMutation(
    //                 {
    //                     email: '',
    //                     mobile: '',
    //                 }
    //             );

    //             // setAddEyeTestConfig((prev) => {
    //             //     return {
    //             //         ...prev,
    //             //         opticianEmail: tempOpticianList.data.filter(
    //             //             (item) => item.email === user.email
    //             //         )[0]?.email,
    //             //         patientEmail: state?.patientEmail
    //             //             ? tempPatientList.data.filter(
    //             //                   (item) => item.email === state?.patientEmail
    //             //               )[0]?.email
    //             //             : '',
    //             //     };
    //             // });

    //             console.log('State --> eyeTestAdd.jsx --> 307 --> ', state);

    //             setAddEyeTestConfig((prev) => {
    //                 return {
    //                     ...prev,
    //                     opticianEmail: tempOpticianList.data.filter(
    //                         (item) => item.email === user.email
    //                     )[0]?.email,
    //                     patientEmail: state?.patientEmail
    //                         ? tempPatientDropdownList.data.filter(
    //                             (item) => item.email === state?.patientEmail
    //                         )[0]?.email
    //                         : getSecureItem('patientEmail')
    //                             ? getSecureItem('patientEmail')
    //                                 .patientEmail
    //                             : '',
    //                 };
    //             });
    //             setLoading(false);
    //         })();
    //     }
    // }, [loading]);
    useEffect(() => {
        if (!loading) return;

        (async () => {
            const tempPosList = await posListMutation({
                email: '',
                mobile: '',
            });

            const tempDoctorList = await doctorListMutation({
                email: '',
                mobile: '',
            });

            const tempOpticianList = await opticianListMutation({
                email: '',
                mobile: '',
            });

            const tempPatientDropdownList = await patientDropdownListMutation({
                email: '',
                mobile: '',
            });

            setAddEyeTestConfig((prev) => ({
                ...prev,
                opticianEmail: tempOpticianList.data.find(
                    (item) => item.email === user.email
                )?.email || '',

                // ✅ ONLY use router state
                patientEmail: state?.fromPatient
                    ? state?.patientEmail
                    : '',
            }));

            setLoading(false);
        })();
    }, [loading]);

    const handleChange = (e) => {
        e.preventDefault();
        const { name, value } = e.target;

        if (name === 'resultExamine') {
            setAddEyeTestConfig((prev) => {
                return {
                    ...prev,
                    [name]: value,
                    infoResultExamine: value,
                };
            });
        } else {
            setAddEyeTestConfig((prev) => {
                return {
                    ...prev,
                    [name]: value,
                };
            });
        }

        // Check character limit for textareas
        if (name in charLimitErrors) {
            if (value.length > 500) {
                setCharLimitErrors((prev) => ({ ...prev, [name]: true }));
            } else {
                setCharLimitErrors((prev) => ({ ...prev, [name]: false }));
            }
        }

        if (name === 'doYouWearGlasses') {
            setAddEyeTestConfig((prev) => {
                return {
                    ...prev,
                    [name]: value,
                    doYouWearGlasses: value == 'true' ? true : false,
                };
            });
        } else {
            setAddEyeTestConfig((prev) => {
                return {
                    ...prev,
                    [name]: value,
                };
            });
        }
    };

    const handleSelectChange = ({ value }, { name }) => {
        setAddEyeTestConfig((prev) => {
            return {
                ...prev,
                [name]: value,
            };
        });

        console.log(
            'ADDEYETESTCONFIG =================================================== ',
            addEyeTestConfig
        );
    };

    const checkAllFalse = (values) => {
        // "false,FrequentFloaters,false,false,false,false,false,false,false"
        const valuesArray = values.split(',');
        for (const value of valuesArray) {
            if (value.trim().toLowerCase() !== 'false') {
                return false;
            }
        }
        return true;
    };

    const checkADDDetailsValues = (details, filterItem) => {
        let filterList = details.filter((item) => item.testType == filterItem);

        // Check if ADD values are different between eyes
        if (
            filterList.length === 2 &&
            filterList[0].add !== filterList[1].add
        ) {
            return true; // Error: ADD values are different
        }
        return false; // No error: ADD values are the same
    };

    const checkSPHForLens = (details, filterItem) => {
        let filterList = details.filter((item) => item.testType == filterItem);
        const hasSmallValue = filterList.some(
            (item) => item.sph === '+0.25' || item.sph === '-0.25'
        );

        const allOtherValuesZero = filterList.every(
            (item) =>
                (item.sph === '0.00' ||
                    item.sph === '+0.25' ||
                    item.sph === '-0.25') &&
                item.cyl === '0.00' &&
                item.axe === '0.00' &&
                item.add === '0.00' &&
                item.pd === '0.00'
        );

        return hasSmallValue && allOtherValuesZero;
    };

    const checkRefractionNotIdentical = (objective, subjective) => {
        const fields = ['sph', 'cyl', 'axe', 'add', 'pd'];

        // Check if ALL fields are identical
        const identical = fields.every((field) => {
            const objVal = parseFloat(
                String(objective[0][field]).replace('+', '')
            );
            const subVal = parseFloat(
                String(subjective[0][field]).replace('+', '')
            );
            console.log('checkRefractionNotIdentical objval ---->> ', objVal);
            console.log('checkRefractionNotIdentical subVal ---->> ', subVal);

            const ov = isNaN(objVal) ? 0 : objVal;
            const sv = isNaN(subVal) ? 0 : subVal;

            console.log('ov value ---> ', ov);
            console.log('sv value ---> ', sv);

            if (ov === 0 && sv === 0) {
                return false;
            }
            return ov === sv;
        });

        console.log('identical ----> ', identical);

        return identical ? 'error' : '';
    };

    const checkSPHighest = (details, filterItem) => {
        const sphThreshold = 6.0;
        let filterList = details.filter((item) => item.testType == filterItem);
        const hasHighSPH = filterList.some(
            (item) => Math.abs(Number(item.sph)) > sphThreshold
        );
        if (hasHighSPH) setTestDetailsSPHModalCount(true);
        return hasHighSPH ? 'error' : '';
    };

    const checkCYLhighest = (details, filterItem) => {
        const cylThreshold = 3.0;
        let filterList = details.filter((item) => item.testType == filterItem);
        const hasHighCYL = filterList.some(
            (item) => Math.abs(Number(item.cyl)) > cylThreshold
        );

        return hasHighCYL ? 'error' : '';
    };
    const checkCorrectionPortee = (details, filterItem) => {
        let filterList = details.filter((item) => item.testType == filterItem);

        const hasAnyValue = (item) =>
            item.sph !== '0.00' ||
            item.axe !== '0.00' ||
            item.cyl !== '0.00' ||
            item.add !== '0.00' ||
            item.pd !== '0.00';

        const rightEye = filterList.find(i => i.whichEye === 'right');
        const leftEye = filterList.find(i => i.whichEye === 'left');

        const rightHasValue = rightEye && hasAnyValue(rightEye);
        const leftHasValue = leftEye && hasAnyValue(leftEye);

        return (!rightHasValue && !leftHasValue) ? 'error' : '';

        // const checkCorrectionPortee = filterList.some(
        //     (item) =>
        //         item.sph == '0.00' &&
        //         item.axe == '0.00' &&
        //         item.cyl == '0.00' &&
        //         item.add == '0.00' &&
        //         item.pd == '0.00'
        // );

        // return checkCorrectionPortee ? 'error' : '';
    };
    const checkProgressive = (details, filterItem) => {
        let filterList = details.filter((item) => item.testType == filterItem);
        const checkProgressivereturn = filterList.some(
            (item) => item.add == '0.00'
        );

        return checkProgressivereturn ? 'error' : '';
    };

    const checkSphCylValues = () => {
        const testDetails = addEyeTestConfig.testDetails;

        for (let i = 2; i < testDetails.length; i++) {
            const { sph, cyl } = testDetails[i];

            const sphValue = parseFloat(sph);
            const cylValue = parseFloat(cyl);

            // Check if values are outside valid range
            if (
                sphValue < -6 ||
                sphValue > 6 ||
                cylValue < -3 ||
                cylValue > 3
            ) {
                return false; // invalid → modal should enable
            }
        }

        return true; // all valid
    };

    const checkDetailsValues = (details, filterItem) => {
        if (
            addEyeTestConfig.doYouWearGlasses == true &&
            filterItem == 'Test au fronto'
        ) {
            const checkCorrectionPorteefilter = checkCorrectionPortee(
                details,
                filterItem
            );
            // If “patient wears glasses” = “yes” and no values are entered for “correction portee” : warning message
            if (checkCorrectionPorteefilter == 'error') {
                if (!patientWearsGlassesModalFor2ndTime) {
                    setSecureItem(
                        'patientWearsGlassesModalLs', true
                    );
                    setPatientWearsGlassesModal(true);
                    setPatientWearsGlassesModalFor2ndTime(true);
                }
                // return 'patientglasswarning';
            }
        } else if (
            (addEyeTestConfig.typeOfVision == 'Progressive Vision' ||
                addEyeTestConfig.typeOfVision == 'Vision progressive') &&
            (filterItem == 'Test au fronto' || filterItem == 'Reco opticien')
        ) {
            const checkprogressivefilter = checkProgressive(
                details,
                filterItem
            );
            if (checkprogressivefilter == 'error') {
                // If “type de vision” = “Progressive” but there are no values for “ADD” in “correction portee” / “recommendation optician” : warning message
                if (!progressivewarningModalFor2ndTime) {
                    setSecureItem(
                        'progressivewarningModalLs', true
                    );
                    setProgressivewarningModal(true);
                    setProgressivewarningModalFor2ndTime(true);
                }
                // return 'progressivewarning';
            }
        } else if (filterItem != 'Test au fronto') {
            const filterList = details.filter(
                (item) => item.testType === filterItem
            );

            if (!state.glass && checkSPHForLens(details, filterItem)) {
                return 'errorForSPH';
            }
            if (!filterList || filterList.length === 0) {
                return 'mustEnterValue';
            }
            const rightobjective = details.filter(
                (item) =>
                    item.testType === 'Auto ref' && item.whichEye === 'right'
            );
            const leftobjective = details.filter(
                (item) =>
                    item.testType === 'Auto ref' && item.whichEye === 'left'
            );

            const rightsubjective = details.filter(
                (item) =>
                    item.testType === 'Réfraction subjective (manuelle)' &&
                    details[4] &&
                    item.whichEye === 'right'
            );
            const leftsubjective = details.filter(
                (item) =>
                    item.testType === 'Réfraction subjective (manuelle)' &&
                    details[5] &&
                    item.whichEye === 'left'
            );

            const odError = checkRefractionNotIdentical(
                rightobjective,
                rightsubjective
            );
            const ogError = checkRefractionNotIdentical(
                leftobjective,
                leftsubjective
            );

            if (odError == 'error' && ogError == 'error') {
                // Objective refraction & subjective refraction can not be identical
                if (!refractionNotIdenticalModalFor2ndTime) {
                    setSecureItem(
                        'refractionNotIdenticalModalLs', true
                    );
                    setRefractionNotIdenticalModal(true);
                    setRefractionNotIdenticalModalFor2ndTime(true);
                }
                // return 'subobjwarning';
                // return false;
            }

            // common function for both <<<<<<<<<<<
            const sphcylvalue = checkSphCylValues();
            if (!sphcylvalue) {
                if (!sphcylvalueModalFor2ndTime) {
                    setSecureItem(
                        'sphcylvalueModalLs', true
                    );
                    setSphcylvalueModal(true);
                    setSphcylvalueModalFor2ndTime(true);
                }
            }

            // const SphHeighest = checkSPHighest(details, filterItem);
            // if (SphHeighest == 'error' && testDetailsSPHModalCount == true) {
            //     setTestDetailsSPHModal(true);
            //     // return 'sphwarning';
            // }

            // const CylHeighest = checkCYLhighest(details, filterItem);
            // if (CylHeighest == 'error' && testDetailsCYLModalCount == true) {
            //     setTestDetailsCYLModal(true);
            //     // return 'cylwarning';
            // }

            for (const item of filterList) {
                const sphStr = (item.sph ?? '0.00').toString();
                const axeStr = (item.axe ?? '0.00').toString();
                const cylStr = (item.cyl ?? '0.00').toString();
                const addStr = (item.add ?? '0.00').toString();
                const pdStr = (item.pd ?? '0.00').toString();

                const hasAnyValue =
                    sphStr !== '0.00' ||
                    axeStr !== '0.00' ||
                    cylStr !== '0.00' ||
                    addStr !== '0.00' ||
                    pdStr !== '0.00';

                if (hasAnyValue) {
                    if (
                        (axeStr !== '0.00' && cylStr === '0.00') ||
                        (axeStr === '0.00' && cylStr !== '0.00')
                    ) {
                        return 'errorForCylAxl';
                    }
                    return false;
                }
            }
            return 'mustEnterValue';
        }
    };

    // const checkDetailsValues = (details, filterItem) =>
    //     {
    //     const  sphThreshold = 6.0;
    //     const   cylThreshold = 3.0;

    //     let filterList = details.filter((item) => item.testType == filterItem);

    //     // First check for lens-specific validation if this is a contact lens test
    //     if (!state.glass && checkSPHForLens(details, filterItem)) {
    //         return 'errorForSPH';
    //     }

    //     for (const item of filterList)
    //     {
    //         if (
    //             item.sph !== '0.00' ||
    //             item.axe !== '0.00' ||
    //             item.cyl !== '0.00' ||
    //             item.add !== '0.00' ||
    //             item.pd !== '0.00'
    //         )
    //         {
    //             if (
    //                 (item.axe !== '0.00' && item.cyl == '0.00') ||
    //                 (item.axe == '0.00' && item.cyl !== '0.00')
    //             )
    //             {
    //                 return 'errorForCylAxl';
    //             }
    //             return false;
    //         }

    //     }
    //     for (const item of filterList)
    //     {
    //       if (Math.abs(Number(item.sph)) > sphThreshold)
    //      {
    //           return 'sphwarning';
    //      }
    //      else if(Math.abs(Number(item.cyl)) > cylThreshold )
    //      {
    //         return 'cylwarning';
    //      }
    //     //    return false;

    //     }
    //     return 'mustEnterValue';
    // };

    // Check if any textarea exceeds character limit
    const hasCharLimitErrors = () => {
        return Object.values(charLimitErrors).some((error) => error === true);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        // Check for character limit errors before proceeding
        if (hasCharLimitErrors()) {
            Swal.fire({
                icon: 'error',
                title: 'Limite de caractères dépassée',
                text: 'Please ensure all text fields have 500 characters or less.Veuillez vous assurer que tous les champs de texte contiennent 500 caractères ou moins.',
            });
            return;
        }

        // Step 1 validation
        // Step 1 validation
        if (currentStep == 1) {
            // Required fields validation
            if (
                addEyeTestConfig.lastTimeWentToEyeDoc == undefined ||
                addEyeTestConfig.posEmail == '' ||
                addEyeTestConfig.patientEmail == '' ||
                addEyeTestConfig.opticianEmail == '' ||
                addEyeTestConfig.opticianEmail == undefined
            ) {
                setError((prev) => ({
                    ...prev,
                    lastTimeWentToEyeDoc:
                        addEyeTestConfig.lastTimeWentToEyeDoc == undefined,
                    posEmail: addEyeTestConfig.posEmail == '',
                    patientEmail: addEyeTestConfig.patientEmail == '',
                    opticianEmail:
                        addEyeTestConfig.opticianEmail == undefined ||
                        addEyeTestConfig.opticianEmail == '',
                }));
                return;
            }

            // 🔒 MANDATORY AGE VALIDATION (CONTACT LENS ONLY)
            if (!state?.glass) {
                // Age not yet loaded → block
                if (typeof selectedPatientAge !== 'number') {
                    Swal.fire({
                        icon: 'warning',
                        title: t('attention'),
                        text: t('pleaseSelectPatientAndWait'),
                    });
                    return;
                }

                // Under 18 → block
                if (selectedPatientAge < 18) {
                    setModalActive(true);
                    return;
                }
            }
        }
        // ✅ only run Step 2–4 validations if resultExamine is NOT retourOphtalmologue / sansOrdonnance
        const shouldValidateNextSteps =
            addEyeTestConfig.resultExamine !== 'Retour ophtalmologue' &&
            addEyeTestConfig.resultExamine !== 'Sans ordonnance';

        if (shouldValidateNextSteps) {
            // Step 2 validation
            if (currentStep === 2) {
                console.log('834 - eyetestadd.jsx - currentStep === 2');

                // Check if all sections have only "false" values (no selections)
                const allFalse =
                    checkAllFalse(addEyeTestConfig.symptoms) &&
                    checkAllFalse(addEyeTestConfig.dignosedwith) &&
                    checkAllFalse(addEyeTestConfig.healthConditions);

                // Check if "None of the Above" is selected in ALL sections
                const checkForNoneOfTheAbove = (section) => {
                    const valuesArray = section.split(',');
                    return valuesArray.some(value =>
                        value.trim().toLowerCase() === 'none of the above'
                    );
                };

                const allNoneOfTheAbove =
                    checkForNoneOfTheAbove(addEyeTestConfig.symptoms) &&
                    checkForNoneOfTheAbove(addEyeTestConfig.dignosedwith) &&
                    checkForNoneOfTheAbove(addEyeTestConfig.healthConditions);

                console.log('allFalse:', allFalse);
                console.log('allNoneOfTheAbove:', allNoneOfTheAbove);

                // If everything is false OR all have "None of the Above" selected, show error
                if (allFalse && !allNoneOfTheAbove) {
                    setError((prev) => {
                        return {
                            ...prev,
                            symptoms: checkAllFalse(addEyeTestConfig.symptoms),
                            dignosedwith: checkAllFalse(addEyeTestConfig.dignosedwith),
                            healthConditions: checkAllFalse(addEyeTestConfig.healthConditions),
                        };
                    });
                    return;
                }

                // If all sections have "None of the Above" selected, we can proceed
                // without requiring symptom comment
                if (allNoneOfTheAbove) {
                    setError((prev) => {
                        return {
                            ...prev,
                            symptoms: false,
                            dignosedwith: false,
                            healthConditions: false,
                        };
                    });
                    // Also clear symptom comment requirement
                    setSymptomcomment(false);
                } else {
                    // Otherwise, check individual sections
                    if (
                        checkAllFalse(addEyeTestConfig.symptoms) ||
                        checkAllFalse(addEyeTestConfig.dignosedwith) ||
                        checkAllFalse(addEyeTestConfig.healthConditions)
                    ) {
                        setError((prev) => {
                            return {
                                ...prev,
                                symptoms: checkAllFalse(addEyeTestConfig.symptoms),
                                dignosedwith: checkAllFalse(addEyeTestConfig.dignosedwith),
                                healthConditions: checkAllFalse(addEyeTestConfig.healthConditions),
                            };
                        });
                        return;
                    }

                    setError((prev) => {
                        return {
                            ...prev,
                            symptoms: false,
                            dignosedwith: false,
                            healthConditions: false,
                        };
                    });
                }
            }
            // Step 3 validation
            if (currentStep === 3) {
                const testAufrontocheck = checkDetailsValues(
                    addEyeTestConfig.testDetails,
                    'Test au fronto'
                );
                const autoRefCheck = checkDetailsValues(
                    addEyeTestConfig.testDetails,
                    'Auto ref'
                );
                const refractionCheck = checkDetailsValues(
                    addEyeTestConfig.testDetails,
                    'Réfraction subjective (manuelle)'
                );
                const recoCheck = checkDetailsValues(
                    addEyeTestConfig.testDetails,
                    'Reco opticien'
                );

                if (recoCheck === 'errorForSPH') {
                    setError((prev) => ({
                        ...prev,
                        reco_opticien: 'errorForSPH',
                    }));
                    return;
                }

                if (
                    testAufrontocheck ||
                    autoRefCheck ||
                    refractionCheck ||
                    recoCheck ||
                    addEyeTestConfig.info_Acuity_Near_Vision_Left_Eye == '' ||
                    addEyeTestConfig.info_Acuity_Distance_Vision_Left_Eye ==
                    '' ||
                    addEyeTestConfig.info_Acuity_Near_Vision_Right_Eye == '' ||
                    addEyeTestConfig.info_Acuity_Distance_Vision_Right_Eye == ''
                ) {
                    setError((prev) => {
                        return {
                            ...prev,
                            testAufronto: testAufrontocheck,
                            auto_ref: autoRefCheck,
                            refraction: refractionCheck,
                            reco_opticien: recoCheck,
                            info_Acuity_Near_Vision_Left_Eye:
                                addEyeTestConfig.info_Acuity_Near_Vision_Left_Eye ==
                                '',
                            info_Acuity_Distance_Vision_Left_Eye:
                                addEyeTestConfig.info_Acuity_Distance_Vision_Left_Eye ==
                                '',
                            info_Acuity_Near_Vision_Right_Eye:
                                addEyeTestConfig.info_Acuity_Near_Vision_Right_Eye ==
                                '',
                            info_Acuity_Distance_Vision_Right_Eye:
                                addEyeTestConfig.info_Acuity_Distance_Vision_Right_Eye ==
                                '',
                        };
                    });
                    return;
                }

                // Check for ADD values differences
                const frontoAddError = checkADDDetailsValues(
                    addEyeTestConfig.testDetails,
                    'Test au fronto'
                );
                const autoRefAddError = checkADDDetailsValues(
                    addEyeTestConfig.testDetails,
                    'Auto ref'
                );
                const refractionAddError = checkADDDetailsValues(
                    addEyeTestConfig.testDetails,
                    'Réfraction subjective (manuelle)'
                );
                const recoAddError = checkADDDetailsValues(
                    addEyeTestConfig.testDetails,
                    'Reco opticien'
                );

                if (
                    (frontoAddError ||
                        autoRefAddError ||
                        refractionAddError ||
                        recoAddError) &&
                    testDetailsAddModalCount
                ) {
                    setTestDetailsAddModal(true);
                    return;
                }
                console.log('currentstep = 33333 ==>>');
                console.log('sphcylvalueModal:', sphcylvalueModal);
                console.log(
                    'patientWearsGlassesModal:',
                    patientWearsGlassesModal
                );
                console.log(
                    'progressivewarningModal:',
                    progressivewarningModal
                );
                console.log(
                    'refractionNotIdenticalModal:',
                    refractionNotIdenticalModal
                );

                const sphcylvalueModalLs =
                    getSecureItem('sphcylvalueModalLs'
                    );
                const patientWearsGlassesModalLs =
                    getSecureItem('patientWearsGlassesModalLs'
                    );
                const progressivewarningModalLs =
                    getSecureItem('progressivewarningModalLs'
                    );
                const refractionNotIdenticalModalLs =
                    getSecureItem('refractionNotIdenticalModalLs'
                    );
                if (
                    sphcylvalueModalLs == true ||
                    patientWearsGlassesModalLs == true ||
                    progressivewarningModalLs == true ||
                    refractionNotIdenticalModalLs == true
                ) {
                    return;
                }
                // ⚠️ NON-BLOCKING BUT HOLD NAVIGATION
                if (
                    addEyeTestConfig.lastTimeWentToEyeDoc === "" &&
                    hasCorrectionCarriedValues(addEyeTestConfig.testDetails) &&
                    !neverSeenWarningShown
                ) {
                    setNeverSeenWarningModal(true);
                    setNeverSeenWarningShown(true);
                    return; // ⛔ STOP navigation for now
                }
            }
        }

        if (currentStep === 2) {
            // if (addEyeTestConfig?.symptomComment === "") {
            //     console.log(
            //         '995  if condition - true statement - symptomcomment +++++++++++++++++++++> ',
            //         symptomcomment
            //     );
            //     setSymptomcomment(true);
            //     return;
            // } else {
            //     console.log(
            //         '1001  if condition - false statement - symptomcomment +++++++++++++++++++++> ',
            //         symptomcomment
            //     );
            //     setSymptomcomment(false);
            // }

            /**
             * if the comment or the error is not in place then it won't
             * go ahead to the next step
             */
            if (symptomcomment) {
                console.log('line 847 - eyetestadd.jsx - if(symptomcomment)');
                return;
            }
        }

        if (currentStep == 4) {
            if (addEyeTestConfig.infoPrescriptionToOptician) {
                if (user?.userType == 'OPTICIAN') {
                    setPreview(true);
                } else {
                    submit();
                }
            } else {
                setError((prev) => {
                    return {
                        ...prev,
                        infoPrescriptionToOptician: true,
                    };
                });
                return;
            }
        }

        setError({ ...defaultError });
        handleNextStep();

        scrollContainerRef.current?.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };

    const submit = () => {
        setButtonLoading(true);
        addEyeTest(addEyeTestConfig).then(async (data) => {
            if (typeof data.error.data === 'string') {
                if (images.image1) {
                    let formData = new FormData();
                    formData.append('EyeTestId', data.error.data);
                    formData.append('EyeTestImage', images.image1);
                    await imageUpload1(formData);
                }
                if (images.image2) {
                    let formData = new FormData();
                    formData.append('EyeTestId', data.error.data);
                    formData.append('EyeTestImage', images.image2);
                    await imageUpload2(formData);
                }
                if (images.image3) {
                    let formData = new FormData();
                    formData.append('EyeTestId', data.error.data);
                    formData.append('EyeTestImage', images.image3);
                    await imageUpload3(formData);
                }
                navigate(`/eyetest/list`);
            }
            setButtonLoading(false);
        });
    };

const imageHandleImgAndPdf = (e) => {
    const file = e.target.files[0];
    const name = e.target.name;
    const newKey = `${name}_preview`;

    if (!file) return;

    // ✅ 1. Check 0 KB file
    if (file.size === 0) {
        Swal.fire("Error", "Le fichier est vide (0 Ko). Veuillez télécharger un fichier valide.", "error");
        e.target.value = null;
        return;
    }

    // ✅ 2. Allowed types
    const allowedTypes = [
        "image/jpeg",
        "image/jpg",
        "image/png",
        "application/pdf",
    ];

    if (!allowedTypes.includes(file.type)) {
       Swal.fire("Error", "Seuls les formats JPG, PNG ou PDF sont autorisés", "error");
        e.target.value = null;
        return;
    }
    let previewUrl = null;

    if (file.type.startsWith("image/") || file.type === "application/pdf") {
        previewUrl = URL.createObjectURL(file);
    }
    setImages((prev) => ({
        ...prev,
        [name]: file,
        [newKey]: previewUrl,
    }));
};
const imageHandleImgOnly = (e) => {
    const file = e.target.files[0];
    const name = e.target.name;
    const newKey = `${name}_preview`;

    if (!file) return;

    // ✅ 1. Check 0 KB file
    if (file.size === 0) {
        e.target.value = '';
        setImages((prev) => ({
            ...prev,
            [name]: '',
            [newKey]: '',
        }));
        setIsImageValid(true);
       Swal.fire("Error", "Le fichier est vide (0 Ko). Veuillez télécharger un fichier valide.", "error");
        return;
    }

    // ✅ 2. Allowed types
    const allowedTypes = ["image/png", "image/jpeg", "image/jpg"];

    if (allowedTypes.includes(file.type)) {
        const previewUrl = URL.createObjectURL(file);

        setImages((prev) => ({
            ...prev,
            [name]: file,
            [newKey]: previewUrl,
        }));

        setIsImageValid(false); // ✅ valid image
    } else {
        // ❌ Invalid file type
        e.target.value = '';
        setImages((prev) => ({
            ...prev,
            [name]: '',
            [newKey]: '',
        }));
        setIsImageValid(true);
       Swal.fire("Error", "Seuls les formats JPG ou PNG sont autorisés", "error");
    }
};

    useEffect(() => {
        console.log('images from eyeTestAdd.jsx === ', images);
    }, [images]);

    if (loading) {
        return <LoadingComponent />;
    }

    return (
        <>
            {preview ? (
                <div>
                    <Preview
                        error={error}
                        handleSelectChange={handleSelectChange}
                        setAddEyeTestConfig={setAddEyeTestConfig}
                        addEyeTestConfig={addEyeTestConfig}
                        handleChange={handleChange}
                        imageHandle={imageHandleImgAndPdf}
                        glass={state.glass}
                        view={'add'}
                        submit={submit}
                        images={images}
                        setPreview={setPreview}
                        buttonLoading={buttonLoading}
                    />
                </div>
            ) : (
                <Form onSubmit={handleSubmit}>
                    <Container fluid className="list_wrapper">
                        <Stack direction="horizontal" gap={3} className="mb-3">
                            <div className="">
                                <h3>{t('addNewEyetest')}</h3>
                            </div>
                        </Stack>
                    </Container>
                    <Container fluid>
                        <Row>
                            <Col md={4}>
                                <ListGroup className="eye_steps">
                                    {steps.map((item, index) => (
                                        <ListGroup.Item
                                            key={index}
                                            active={index + 1 === currentStep}
                                        >
                                            {item.title}{' '}
                                            {index < currentStep && (
                                                <Check />
                                            )}{' '}
                                        </ListGroup.Item>
                                    ))}
                                </ListGroup>
                            </Col>
                            <Col md={8}>
                                {currentStep === 1 && (
                                    <Step1
                                        error={error}
                                        handleSelectChange={handleSelectChange}
                                        setAddEyeTestConfig={
                                            setAddEyeTestConfig
                                        }
                                        modalActive={modalActive}
                                        setModalActive={setModalActive}
                                        selectedPatientAge={selectedPatientAge}
                                        setSelectedPatientAge={
                                            setSelectedPatientAge
                                        }
                                        addEyeTestConfig={addEyeTestConfig}
                                        handleChange={handleChange}
                                        view={'add'}
                                        glass={state.glass}
                                        imageHandle={imageHandleImgAndPdf}
                                        images={images}
                                    />
                                )}

                                {currentStep === 2 && (
                                    <Step2
                                        error={error}
                                        handleSelectChange={handleSelectChange}
                                        setAddEyeTestConfig={
                                            setAddEyeTestConfig
                                        }
                                        addEyeTestConfig={addEyeTestConfig}
                                        view={'add'}
                                        symptomcomment={symptomcomment}
                                        setSymptomcomment={setSymptomcomment}
                                    />
                                )}

                                {currentStep === 3 && (
                                    <Step3
                                        error={error}
                                        handleSelectChange={handleSelectChange}
                                        setAddEyeTestConfig={
                                            setAddEyeTestConfig
                                        }
                                        addEyeTestConfig={addEyeTestConfig}
                                        handleChange={handleChange}
                                        imageHandle={imageHandleImgOnly}
                                        glass={state.glass}
                                        view={'add'}
                                        images={images}
                                    />
                                )}

                                {currentStep === 4 && (
                                    <Step4
                                        error={error}
                                        handleSelectChange={handleSelectChange}
                                        setAddEyeTestConfig={
                                            setAddEyeTestConfig
                                        }
                                        addEyeTestConfig={addEyeTestConfig}
                                        handleChange={handleChange}
                                        glass={state.glass}
                                        view={'add'}
                                        charLimitErrors={charLimitErrors}
                                        setCharLimitErrors={setCharLimitErrors}
                                    />
                                )}
                            </Col>
                        </Row>
                        <Modal
                            show={isImageValid}
                            backdrop="static"
                            keyboard={false}
                        >
                            <Modal.Body className="text-center">
                                <CircleAlert
                                    size={60}
                                    className="mb-4 mt-4"
                                    color="#f8bb86"
                                />
                                <p>
                                    <b>{t('attention2')}</b>
                                </p>
                                <p> {t('errorImageTypeInvalid')}</p>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button
                                    variant="light"
                                    onClick={() => {
                                        setIsImageValid(false);
                                    }}
                                >
                                    Ok
                                </Button>
                            </Modal.Footer>
                        </Modal>
                        <Modal
                            show={testDetailsAddModal}
                            backdrop="static"
                            keyboard={false}
                        >
                            <Modal.Body className="text-center">
                                <CircleAlert
                                    size={60}
                                    className="mb-4 mt-4"
                                    color="#f8bb86"
                                />
                                <p>
                                    <b>{t('attention')}</b>
                                </p>
                                <p> {t('errorForAdd')}</p>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button
                                    variant="light"
                                    onClick={() => {
                                        setTestDetailsAddModalCount(false);
                                        setTestDetailsAddModal(false);
                                    }}
                                >
                                    {t('okay')}
                                </Button>
                            </Modal.Footer>
                        </Modal>
                        <Modal
                            show={sphcylvalueModal}
                            backdrop="static"
                            keyboard={false}
                        >
                            <Modal.Body className="text-center">
                                <CircleAlert
                                    size={60}
                                    className="mb-4 mt-4"
                                    color="#f8bb86"
                                />
                                {/* <p>
                                    <b>{t('attention')}</b>
                                </p> */}
                                <p> {t('sphwarning')}</p>
                                {/* <p> {t('cylwarning')}</p> */}
                            </Modal.Body>
                            <Modal.Footer>
                                <Button
                                    variant="light"
                                    onClick={() => {
                                        setSecureItem(
                                            'sphcylvalueModalLs', false
                                        );
                                        setSphcylvalueModal(false);
                                    }}
                                >
                                    {t('okay')}
                                </Button>
                            </Modal.Footer>
                        </Modal>
                        <div className="d-flex justify-content-end mt-3">
                            <Button variant="light" onClick={handlePrevStep}>
                                {t('cancel')}
                            </Button>
                            {'  '}
                            <Button
                                type="submit"
                                variant="primary"
                                disabled={buttonLoading}
                            >
                                {buttonLoading && (
                                    <Spinner
                                        animation="border"
                                        role="status"
                                        size="sm"
                                    >
                                        <span className="visually-hidden">
                                            Loading...
                                        </span>
                                    </Spinner>
                                )}{' '}
                                {currentStep === 4
                                    ? t('saveAndNextLastStep')
                                    : t('saveAndNext')}
                            </Button>
                        </div>
                    </Container>
                    <Modal
                        show={modalActive}
                        backdrop="static"
                        keyboard={false}
                    >
                        <Modal.Body className="text-center">
                            <CircleAlert
                                size={60}
                                className="mb-4 mt-4"
                                color="#f8bb86"
                            />
                            <p>
                                {t(
                                    'Les tests de lentilles ne sont pas autorisés pour les patients de moins de 18 ans.'
                                )}
                            </p>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button
                                variant="secondary"
                                onClick={() => setModalActive(false)}
                            >
                                {t('okay')}
                            </Button>
                        </Modal.Footer>
                    </Modal>
                    {/*  */}
                    <Modal
                        show={progressivewarningModal}
                        backdrop="static"
                        keyboard={false}
                    >
                        <Modal.Body className="text-center">
                            <CircleAlert
                                size={60}
                                className="mb-4 mt-4"
                                color="#f8bb86"
                            />
                            <p>{t('progressivewarning')}</p>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button
                                variant="secondary"
                                onClick={() => {
                                    setSecureItem(
                                        'progressivewarningModalLs', false
                                    );
                                    setProgressivewarningModal(false);
                                }}
                            >
                                {t('okay')}
                            </Button>
                        </Modal.Footer>
                    </Modal>
                    <Modal
                        show={refractionNotIdenticalModal}
                        backdrop="static"
                        keyboard={false}
                    >
                        <Modal.Body className="text-center">
                            <CircleAlert
                                size={60}
                                className="mb-4 mt-4"
                                color="#f8bb86"
                            />
                            <p>{t('subobjwarning')}</p>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button
                                variant="secondary"
                                onClick={() => {
                                    setSecureItem(
                                        'refractionNotIdenticalModalLs', false
                                    );
                                    setRefractionNotIdenticalModal(false);
                                }}
                            >
                                {t('okay')}
                            </Button>
                        </Modal.Footer>
                    </Modal>
                    <Modal
                        show={patientWearsGlassesModal}
                        backdrop="static"
                        keyboard={false}
                    >
                        <Modal.Body className="text-center">
                            <CircleAlert
                                size={60}
                                className="mb-4 mt-4"
                                color="#f8bb86"
                            />
                            <p>{t('patientglasswarning')}</p>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button
                                variant="secondary"
                                onClick={() => {
                                    setSecureItem(
                                        'patientWearsGlassesModalLs', false
                                    );
                                    setPatientWearsGlassesModal(false);
                                }}
                            >
                                {t('okay')}
                            </Button>
                        </Modal.Footer>
                    </Modal>
                    <Modal
                        show={neverSeenWarningModal}
                        backdrop="static"
                        keyboard={false}
                    >
                        <Modal.Body className="text-center">
                            <CircleAlert
                                size={60}
                                className="mb-4 mt-4"
                                color="#f8bb86"
                            />
                            <p>
                                {t('creationportewarningmassage')}
                            </p>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button
                                variant="secondary"
                                onClick={() => {
                                    setSecureItem('neverSeenWarningModalLs', false);
                                    setNeverSeenWarningModal(false);
                                }}
                            >
                                {t('okay')}
                            </Button>
                        </Modal.Footer>
                    </Modal>
                </Form>
            )}
        </>
    );
};

export default EyeTestAdd;
